module.exports = __webpack_public_path__ + "img/ic_download.3c34cd90.svg";